@for (block of blocks; track $index) {
  @switch (block.type) {
    @case ('p') { <p [innerHTML]="html(block.html)"></p> }
    @case ('h2') { <h2 [id]="block.id">{{ block.text }}</h2> }
    @case ('h3') { <h3>{{ block.text }}</h3> }
    @case ('ul') {
      <ul>@for (item of block.items; track $index) { <li [innerHTML]="html(item)"></li> }</ul>
    }
    @case ('ol') {
      <ol>@for (item of block.items; track $index) { <li [innerHTML]="html(item)"></li> }</ol>
    }
    @case ('callout') { <aside class="rounded-md bg-mg-surface p-4">{{ block.text }}</aside> }
    @case ('faq_section') {
      <section>
        @for (item of block.items; track item.q) {
          <h3>{{ item.q }}</h3>
          <div>{{ item.a }}</div>
        }
      </section>
    }
    @case ('error_message') {
      <figure class="kb-error-message">
        <blockquote><p>@if (block.prefix) {<span class="kb-error-prefix">{{ block.prefix + ' ' }}</span>}{{ block.text }}</p></blockquote>
        <figcaption>Fonte: {{ block.source }}</figcaption>
      </figure>
    }
    @case ('image') {
      @let annotations = anotacoes(block.annotations);
      <figure>
        @if (imagem(block.src); as urlImagem) {
          <a [href]="urlImagem" target="_blank" rel="noopener noreferrer"
             [attr.aria-label]="'Ampliar imagem: ' + block.alt + ' (abre em nova aba)'">
            <span class="kb-image-frame">
              <img [src]="urlImagem" [alt]="block.alt" [attr.width]="block.width ?? null"
                   [attr.height]="block.height ?? null" loading="lazy" decoding="async" class="max-w-full h-auto" />
              @for (note of annotations; track $index) {
                <span class="kb-image-marker" aria-hidden="true" [style.left.%]="note.x" [style.top.%]="note.y">{{ $index + 1 }}</span>
              }
            </span>
            <span class="mg-link block">Ampliar imagem (abre em nova aba)</span>
          </a>
        }
        @if (block.caption || annotations.length) {
          <figcaption>{{ block.caption }}@if (annotations.length) {
            <ol class="kb-image-notes" aria-label="Pontos destacados na imagem">
              @for (note of annotations; track $index) { <li>{{ note.text }}</li> }
            </ol>
          }</figcaption>
        }
      </figure>
    }
  }
}
@if (blocoDeErro(article); as followup) {
  <section class="kb-error-followup" [attr.aria-labelledby]="idDoBlocoDeErro">
    <h2 [id]="idDoBlocoDeErro">{{ followup.title }}</h2>
    @if (escopoDoCodigo(article); as escopo) { <p class="kb-error-followup__escopo">{{ escopo }}</p> }
    <p class="kb-error-followup__intro">{{ followup.intro }}</p>
    <ul>@for (item of followup.items; track item) { <li>{{ item }}</li> }</ul>
    <p class="kb-error-followup__suporte">
      <a class="mg-link" data-test="followup-chamado" [routerLink]="rotaNovoChamado" [queryParams]="{ de: rotaDeOrigem() }"
        (click)="aoAbrirChamado()">Abrir chamado sobre esta tela</a>
      <a class="mg-link" data-test="followup-whatsapp" [href]="whatsappDoSuporte" target="_blank" rel="noopener noreferrer"
        >Falar com o suporte no WhatsApp<span class="sr-only"> (abre em nova aba)</span></a>
    </p>
    <div class="kb-error-followup__notes">@for (nota of followup.notes; track nota) { <p>{{ nota }}</p> }</div>
  </section>
}
@if (officialSource; as fonte) {
  @let linkFonte = linkDaFonte(fonte.url);
  @let dataIso = dataIsoDaFonte(fonte.date);
  <p class="kb-official-source"><span class="kb-official-source__rotulo">Fonte oficial: </span>@if (linkFonte) {<a class="mg-link" [href]="linkFonte" target="_blank" rel="noopener noreferrer"
      [attr.aria-label]="fonte.name + ' (abre em nova aba)'">{{ fonte.name }}</a>} @else {<span>{{ fonte.name }}</span>}, versão {{ fonte.version }}, de @if (dataIso) {<time [attr.datetime]="dataIso">{{ dataDaFonte(dataIso) }}</time>} @else {<span>{{ fonte.date }}</span>}.</p>
}
